import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import styled from 'styled-components';

import { showModal, hideReport, showReport } from '../../actions/modal';

import ModalContainer from '../../containers/modal';
import Report from '../../components/report';

import FluidContainer from '../layouts/components/fluid-container';
import ColumnContainer from '../layouts/components/column-container';
import Button from '../button';

import Spacer from '../spacer';
import { GotoSourceButton } from '../buttons-bar';

export const Title = styled.div`
    font-size: 28px;
    font-weight: 300;
    line-height: 36px;
`;

export const Description = styled.div`
    font-size: 16px;
    line-height: 24px;
    padding: 4px;
`;

const ButtonContainer = styled.div`
    position: ${(props) => props.report && 'relative'};
`;

const PageWrapper = styled.div`
    min-height: 100vh;
`;

export const CorrectionLoadError = ({
    bookId,
    homework,
    displayReport,
    showReport,
    hideReport,
    source,
    title,
    children,
    isLtiLaunch,
    backToHome,
}) => {
    const handleClickReport = () => {
        if (displayReport) {
            hideReport();
            return;
        }
        showReport();
    };

    return (
        <PageWrapper>
            <ModalContainer />
            <ColumnContainer width={[0, 1 / 12, 3 / 12]} />
            <ColumnContainer width={[1, 11 / 12, 5 / 12]}>
                <FluidContainer flexDirection="column" paddingTop="base" paddingX={['mobile', 'tablet', 'desktop']}>
                    <Title>{title}</Title>
                    <Description>{children}</Description>
                    <br />
                    <FluidContainer flexDirection={['column', 'row']}>
                        {!isLtiLaunch && source !== null && (
                            <>
                                <ButtonContainer>
                                    <GotoSourceButton
                                        bookId={bookId}
                                        homework={homework}
                                        source={source}
                                        fluid={true}
                                        type="primary"
                                        backToHome={backToHome}
                                    />
                                </ButtonContainer>
                                <Spacer size="base" />
                            </>
                        )}
                        <ButtonContainer report={true}>
                            <Button type="tertiary" fluid={true} onClick={handleClickReport} size="small">
                                {'Contattaci'}
                            </Button>
                            <Report showReport={displayReport} isCorrectionPage={true} />
                        </ButtonContainer>
                    </FluidContainer>
                </FluidContainer>
            </ColumnContainer>
        </PageWrapper>
    );
};

CorrectionLoadError.propTypes = {
    bookId: PropTypes.number,
    homework: PropTypes.shape({
        id: PropTypes.string,
        ugc: PropTypes.number,
    }),
    hideReport: PropTypes.func,
    displayReport: PropTypes.bool,
    showReport: PropTypes.func,
    source: PropTypes.string,
    title: PropTypes.string,
    children: PropTypes.node,
    isLtiLaunch: PropTypes.bool,
    backToHome: PropTypes.bool,
};

const stateToProps = (state) => {
    return {
        bookId: state.application.bookId,
        homework: state.homework,
        displayReport: state.modal.showReport,
        isLtiLaunch: state.application.isLtiLaunch,
        backToHome: state.application.backToHome,
    };
};
const actionCreators = {
    hideReport,
    showModal,
    showReport,
};
export default connect(stateToProps, actionCreators)(CorrectionLoadError);
